/**
 * `@nook/client-ui/core` (iOS block 02, I10): the DOM-free half of this
 * package, for clients that write their own views. Nothing here may import
 * React DOM, `streamdown` or `lucide-react`. Display logic two clients use
 * lives here.
 */
export { citedProse, foldTurn, groupReads, numberedSources, sourceNumbers, sourceTitles, stepDetails, stepLabel, } from "./ask-turn.js";
export { formatClock, formatFullDate, formatShortDate, nookBody, nookContent, nookHost, nookKind, nookTitle, plainText, priceAsOf, readingMinutes, savedLabel, transcriptOf, transcriptTime, withoutLeadImages, withoutTitle, } from "./nook-display.js";
export { browseFilters, DATE_PRESETS, dayStart, localDay, matchPreset, presetRange, } from "./browse.js";
export { formatBytes, normalizeUrl } from "./capture.js";
export { joinNote, splitNote } from "@nook/schema";
export { blocksToNote, inline, isNote, lineSafe, normalizeNote, noteToBlocks, readNote, writeNote } from "./note.js";
export function formatUatThroughDate(exclusiveExpiryIso) {
    return `${new Intl.DateTimeFormat("en-GB", { timeZone: "Asia/Kolkata", day: "numeric", month: "short", year: "numeric" }).format(new Date(Date.parse(exclusiveExpiryIso) - 1))} IST`;
}
//# sourceMappingURL=core.js.map